import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=7c7d6a0c&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=7c7d6a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d6a0c",
  null
  
)

export default component.exports